<template>
  <div class="json-display">
    <h2 v-if="title">title = {{ title }}</h2>
    <pre>data = {{ JSON.stringify(data, null, 2) }}</pre>
  </div>
</template>

<script setup>
defineProps(["data", "title"]);
</script>

<style scoped>
.json-display {
  font-family: monospace;
  background-color: #f9f9f9;
  padding: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: auto;
  max-width: 100%;
  white-space: pre-wrap;
}
</style>
